import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
import store from "store";
import List from "../../container/list";

import styles from "./index.module.scss";

import { TickerProps } from "store/trade";

interface Props {
  records: string[];
  isShowVolume: boolean;
}

const Main: React.FC<Props> = ({ records, isShowVolume }) => {
  // const t = useTranslation();
  const { tickers } = store.trade;

  const tickerAry = useMemo(() => {
    const ary: TickerProps[] = [];
    records.map((marketName) => {
      const doc = tickers.find((obj) => obj.s === marketName);
      doc && ary.push(doc);
    });

    return ary;
  }, [records, tickers]);

  return (
    <>
      {tickerAry.map((ticker) => (
        <List key={ticker.s} ticker={ticker} isShowVolume={isShowVolume} />
      ))}
    </>
  );
};

export default observer(Main);
// export default Main;
